import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, fromEvent, map, Subscription } from 'rxjs';
import { UserRoles } from 'src/app/models/enums/user-roles';
import { FilterParameter } from 'src/app/models/FilterPrameter';
import { IllustrationRequestInputMetadata } from 'src/app/models/illustrationRequestInputMetadata';
import { CommentService } from 'src/app/services/comment.service';
import { CommonService } from 'src/app/services/common/common.service';
import { InformativeService } from 'src/app/services/informative.service';
import { OpportunitiesService } from 'src/app/services/opportunities.service';
import { UserService } from 'src/app/services/user.service';
import { CustomFile, GeneralTaskDto, NotificationStatus, OpportunityDto, TasksStatus } from 'src/app/web-api-client';
import { faCodeBranch } from "@fortawesome/free-solid-svg-icons";
import { IllustrationService } from 'src/app/services/illustration/illustration.service';
import { MessageType, PopupNotificationsService } from 'src/app/services/popup-notifications/popup-notifications.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-illustration-input-request-detail-page',
  templateUrl: './illustration-input-request-detail-page.component.html',
  styleUrls: ['./illustration-input-request-detail-page.component.scss']
})
export class IllustrationInputRequestDetailPageComponent implements OnInit {

// hold the taskId
  faCodeBranch = faCodeBranch;
  taskId: string;
  clientName: string;
  metaData: string[] = [];
  networkMemberId: string;
  networkMemberName: string;
  status: TasksStatus;
  isLoading: boolean = false;
  task: GeneralTaskDto;
  page: number = 1;
  pageSize: number = 30;
 illustrationForm = new UntypedFormGroup({
    ClientName: new UntypedFormControl({ value: '', disabled: true }),
    Country: new UntypedFormControl(''),
    State: new UntypedFormControl(''),
    AccountRepresentative: new UntypedFormControl(''),
    RegionalDirector: new UntypedFormControl(''),
    OpportunityId: new UntypedFormControl({ value: '', disabled: true },[Validators.required]),
    Recipient: new UntypedFormControl('',[Validators.required])
  });
  
  @ViewChild('searchRecipientField', { static: true }) searchInputRecipientField: ElementRef;
  @ViewChild('searchOpportunityField', { static: true }) searchOpportunityField: ElementRef;

  isNetworkMember : boolean;
  isCollaborator : boolean;
  isUSA : boolean;
  isTaskOpen : boolean = false;
  subscriptions: Subscription[] = [];
  searchingOpp: boolean=false;
  filteredOpportunities: OpportunityDto[] = []
  selectedOpp: OpportunityDto;
  isOppSelected:boolean = false;
  statusText: string = "";
  loadingIllustrations: boolean;
  illustrations: GeneralTaskDto[] = [];
  hideShowMoreBtn: boolean;
  // contructor
  constructor(private activatedroute: ActivatedRoute, public informativeTaskService: InformativeService,
    private userService : UserService, private commentService: CommentService,
    private commonService:CommonService,private opportunitiesService:OpportunitiesService,
    public location: Location,private illustrationService : IllustrationService,private router: Router, private notificationService : NotificationService,   private popupNotificationsService: PopupNotificationsService,) {
    this.informativeTaskService.activeTask = null;
  }
 

  // oninit method
  async ngOnInit() {
   
    this.taskId = this.activatedroute.snapshot.paramMap.get("id");
    this.task = await this.informativeTaskService.getInformative(this.taskId);
    this.commentService.discussion = await this.commentService.getDiscussionByTaskId(this.task.id);
    this.commentService.taskSubscribers = await this.commentService.getTaskSubescribersByDiscussionId(this.task.id);
    this.networkMemberId = this.task.networkMemberId
    this.isCollaborator = await this.userService.isUserInRole(UserRoles.Collaborator);
    this.isNetworkMember = await this.userService.isUserInRole(UserRoles.NetworkMember);
    if(this.isCollaborator && this.task.content == null){
      this.illustrationForm.controls.OpportunityId.enable()
    }
    this.isLoading = true;
    this.statusText = this.commonService.getTaskStatusByNumber(this.task.status.value);
    //fill the form
    var metaData: IllustrationRequestInputMetadata =  JSON.parse(this.task.metaData);
    this.illustrationForm.controls.Country.setValue(this.task.subTitle);
    this.illustrationForm.controls.ClientName.setValue(this.task.title);
    this.illustrationForm.controls.AccountRepresentative.setValue(metaData.AccountManager.email);
    this.illustrationForm.controls.RegionalDirector.setValue(metaData.DivisionalManager.email);
    if(this.task.content != null){
      this.illustrationForm.controls.OpportunityId.setValue(this.task.content);
    }
    this.isTaskOpen = this.task.status.value == TasksStatus.Open;
    this.setupSearchListeners();
    if(this.isCollaborator){
      this.loadIllustrations()
    }
    this.commentService.setTask(this.task);
    this.isLoading = false;
  }
  setupSearchListeners() {
    this.subscriptions.push(fromEvent(this.searchOpportunityField.nativeElement, 'keyup').pipe(
      map((event: any) => event.target.value),
      filter(res => res.length > 2),
      debounceTime(100),
      distinctUntilChanged()
    ).subscribe(text => this.fetchOpportunity(text)));
  }
  async fetchOpportunity(text){
    console.log(text);
    
    if (!text) return (this.filteredOpportunities = []);
    this.searchingOpp= true;
    this.isOppSelected = false;
    this.selectedOpp = null
    this.filteredOpportunities = await this.opportunitiesService.getOpportunitiesBySearchingId(text.toLowerCase(), 0, 30);
    this.searchingOpp = false;
  }
  async save(){
    const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    await this.createIllustration()
    await this.changeNotificationStatus()
    await delay(1000);
  
    this.router.navigateByUrl("/all-illustrations");
  }

  async createIllustration() {
    const files = await this.commentService.getAllAttachments(this.task.id);
  
    const customFiles: CustomFile[] = await Promise.all(
      files.map(async (file) => {
        const fileData = `data:application/octet-stream;base64,${await this.commentService.downloadFile(file.commentId, this.taskId, file.id)}`;
        const customFile = new CustomFile();
        customFile.file = fileData;
        customFile.fileName = file.name;
        return customFile;
      })
    );
    var metaData: IllustrationRequestInputMetadata =  JSON.parse(this.task.metaData);
    await this.illustrationService.createIllustration(
      this.task.clientId,
      this.task.title,
      [this.task.country],
      metaData.DivisionalManager.email,
      metaData.DivisionalManager.id,
      metaData.AccountManager.email,
      metaData.AccountManager.id,
      this.task.networkMemberId,
      customFiles
    );
    await this.informativeTaskService.changeTaskStatus(this.task.id,TasksStatus.Finalized)
    this.popupNotificationsService.showMessage("The illustration has been submited",MessageType.Success)
  }

  async reject(){
    const delay = (ms: number) => new Promise(res => setTimeout(res, ms));
   
    var notes = []
    this.commentService.discussion.comments
    .forEach(element => {
      notes.push(element.firstName+" "+element.lastName+", message : "+element.content)
    });
    const files = await this.commentService.getAllAttachments(this.task.id);
    const customFiles: CustomFile[] = await Promise.all(
      files.map(async (file) => {
        const fileData = `data:application/octet-stream;base64,${await this.commentService.downloadFile(file.commentId, this.taskId, file.id)}`;
        const customFile = new CustomFile();
        customFile.file = fileData;
        customFile.fileName = file.name;
        return customFile;
      })
    );
    await this.illustrationService.rejectIllustration(this.task.clientId,notes,customFiles,this.selectedOpp.id,(await this.userService.getCurrentUser()).preferredEmail)
    await this.informativeTaskService.UpsertInformative(
      this.task.networkMemberId, this.task.title,
      this.task.subTitle,this.task.clientId,
      this.task.processId,this.task.id,
      this.task.metaData,this.task.insuropeSubscribers,this.task.status,this.task.sourceId,this.task.country,this.selectedOpp.id
    );
    await this.informativeTaskService.changeTaskStatus(this.task.id,TasksStatus.Closed)
    await this.changeNotificationStatus()
    this.popupNotificationsService.showMessage("The illustration has been rejected", MessageType.Success)
    await delay(1000);
    this.router.navigateByUrl("/all-illustrations");
  }
   async changeNotificationStatus(){
      var discussion = this.commentService.discussion;
      discussion.comments.forEach(async comment => {
        await this.notificationService.ChangeNotificationStatus(comment.id, NotificationStatus.Stopped)
      });
    }
  async merge(illustration : GeneralTaskDto){
    if(confirm("Are you sure to merge this task with the current one ?")){
      await this.informativeTaskService.MergeTasks(illustration.id,this.task.id)
    }
  }
  async loadIllustrations(loadMore = true) {
    this.loadingIllustrations = true;
    let newItems : GeneralTaskDto [] = [];


    const nmId = this.task.networkMemberId


 var filterParameter: FilterParameter = {} as FilterParameter;
      filterParameter.NetworkMemberIds = nmId == null ? null : [nmId];
      filterParameter.ClientId = null;
      filterParameter.ClientName = null;
      filterParameter.SubscriberId = null;
      filterParameter.ProcessId = this.task.processId;
      filterParameter.Status = TasksStatus.Open;
      filterParameter.PayTo = null;
      filterParameter.OverdueDate = null
      filterParameter.NetworkMemberId = nmId
     
    newItems = await this.informativeTaskService.getTasks( filterParameter,null,this.page,this.pageSize);
    newItems = newItems.filter(obj => obj.id !== this.task.id)
    this.hideShowMoreBtn = newItems.length < this.pageSize;
    this.illustrations =  newItems
    document.getElementById("illustrations-view-btn")?.classList.toggle("d-none", this.illustrations.length === 0);
    this.loadingIllustrations = false;
}
  selectOpportunity(opp:OpportunityDto){
    this.selectedOpp = opp;
    this.filteredOpportunities = [];
    this.isOppSelected = true;
    this.searchOpportunityField.nativeElement.value = opp.id;
    this.illustrationForm.controls.OpportunityId.setValue(opp.id);
  }

}
